/** Available account types to compare documents */
export enum DocumentCompareAccountTypeEnum {
  /** Account type "51" - bank */
  BANK_ACCOUNT = '51',
  /** Account type "60.01" - mutual settlements with suppliers */
  MUTUAL_SETTLEMENTS_ACCOUNT = '6001',
  /** Account type "62.01" - prepayments */
  PREPAYMENT_ACCOUNT = '6201',
}
